document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('mousemove', function(e) {
        for (let i = 0; i < 5; i++) {
            let sparkle = document.createElement('div');
            document.body.appendChild(sparkle);

            sparkle.style.position = 'fixed';
            sparkle.style.zIndex = '9999';
            sparkle.style.left = `${e.clientX + (Math.random() * 10 - 5)}px`;
            sparkle.style.top = `${e.clientY + (Math.random() * 10 - 5)}px`;
            let size = Math.random() * 1.5 + 0.5;
            sparkle.style.width = `${size}px`;
            sparkle.style.height = `${size}px`;
            sparkle.style.backgroundColor = `hsl(50, 70%, ${40 + Math.random() * 20}%)`;
            sparkle.style.borderRadius = '50%';
            sparkle.style.boxShadow = `0 0 ${Math.random() * 5 + 2}px #FFD700`;
            sparkle.style.pointerEvents = 'none';

            let fallDuration = Math.random() * 500 + 1000;
            sparkle.animate([
                { transform: 'translateY(0px)', opacity: 1 },
                { transform: `translateY(${50 + Math.random() * 100}px)`, opacity: 0 }
            ], {
                duration: fallDuration,
                easing: 'ease-in'
            });

            setTimeout(() => {
                sparkle.remove();
            }, fallDuration);
        }
    });
});